module.exports = __webpack_public_path__ + "img/logo-woco-trivire-color.27f26a7d.png";